import Swiper, { Navigation, Autoplay } from 'swiper';
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);
if (customElements.get('slider-categories') === undefined) {
    class CategoriesSlider extends HTMLElement {
        constructor() {
            super();
            this.speed = 700;
        }
        connectedCallback() {
            this.start();
        }
        start() {
            const prev = this.querySelector('.nav-button-prev');
            const next = this.querySelector('.nav-button-next');
            this.slider = new Swiper('.swiper-container.collections', {
                modules: [Navigation, Autoplay],
                slidesPerView: 6,
                spaceBetween: 32,
                speed: this.speed,
                centeredSlidesBounds: true,
                centeredSlides: true,
                autoplay: {
                    delay: 2000,
                    disableOnInteraction: false,
                },
                navigation: {
                    nextEl: next,
                    prevEl: prev
                },
                breakpoints: {
                    0: {
                        slidesPerView: 3,
                        spaceBetween: 16,
                        centeredSlides: true,
                        centeredSlidesBounds: true,
                    },
                    700: {
                        slidesPerView: 4,
                        spaceBetween: 22,
                    },
                    999: {
                        slidesPerView: 6,
                        spaceBetween: 32,
                        centeredSlides: false,
                        centeredSlidesBounds: false
                    },
                }
            });
        }
    }
    customElements.define('slider-categories', CategoriesSlider);
}
